export const dedupe = <T>(
	arr: T[],
	areElementsEqual: (t1: T, t2: T) => boolean
): T[] =>
	arr.filter(
		(t1, index1, others) =>
			!others.some(
				(t2, index2) => index1 !== index2 && areElementsEqual(t1, t2)
			)
	);
